// error.service.ts

import { NotificationPayload } from "./NotificationContext";

let NotificationHandler: ((error: NotificationPayload) => void) | null = null;

export const registerNotificationHandler = (
  handler: (e: NotificationPayload) => void,
) => {
  NotificationHandler = handler;
};

export const showNotification = (notif: NotificationPayload) => {
  console.log("Showing notification", notif);

  if (!NotificationHandler) {
    console.warn("Notification handler not registered yet", notif);
    return;
  }
  NotificationHandler(notif);
};
